import React from 'react';
import './Hero.scss';

const Hero: React.FC = () => {
  const handlePurchase = () => {
    window.open('https://shadow-16723594.myshopify.com/products/shadow-tracker', '_blank');
  };

  return (
    <section id="hero" className="hero">
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1>Protect What Matters Most</h1>
            <p>Undetectable GPS tracking for your vehicles and assets. 24 months battery life. Completely invisible to GPS scanners.</p>
            <button onClick={handlePurchase} className="btn-primary">Secure Your Assets Now</button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
